import Services from './base-services'

const service = new Services('metaDataCategory')

export default {
    getMetaDataCategory: () => {
        return service.post('getMetaDataCategory');
    },
}
